type LastVisited = { route: string; id: string };

let lastVisited: LastVisited | null = null;

export const setLastVisited = (route: string, id: string): void => {
  lastVisited = { route, id };
};

export const hasLastVisited = (route: string): boolean => lastVisited?.route === route;

export const consumeLastVisited = (route: string): string | null => {
  if (!lastVisited || lastVisited.route !== route) {
    return null;
  }
  const { id } = lastVisited;
  lastVisited = null;
  return id;
};
